import { Route, Routes } from 'react-router-dom';

import Index from '../pages';
import PackageHistory from '../pages/package';

export function PackageHistorys() {
  return (
    <Routes>
        <Route path='/' element={<Index child={<PackageHistory />}/>} />
    </Routes>
  );
}
